import React from 'react';
import { Link } from '@inertiajs/react';
import { Card } from '~/marketing/ui';
import { formatMeasuredOn } from '~/components/data/format.js';

/* One post, as the blog page and the home page both list it. Everything on it
   is the post's own entry in `blog/posts.json`, so a listing cannot describe a
   post differently from the post. `headingLevel` because the blog page lists
   posts under its h1 and the home page under a section's h2. */
export function PostCard({ post, headingLevel = 'h2' }) {
  const Heading = headingLevel;
  return (
    <Link href={post.path} style={{ color: 'inherit' }}>
      <Card interactive>
        <div style={{ display: 'grid', gap: 10 }}>
          <span className="sp-label"><span className="sp-mono">{formatMeasuredOn(post.published)}</span></span>
          <Heading style={{ fontSize: 'var(--fs-h3)' }}>{post.title}</Heading>
          <p style={{ color: 'var(--text-body)', fontSize: 'var(--fs-body-sm)', margin: 0 }}>{post.summary}</p>
        </div>
      </Card>
    </Link>
  );
}
